<script lang="ts">
	import { Text } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import PremiumUpsellAlert from 'src/components/Premium/PremiumUpsellAlert.svelte';

	export let showAboutAIModelModal = false,
		device;
</script>

<PremiumUpsellAlert
	{device}
	isHeadingBold
	heading={$format('title_upgrade_to_premium_for_ai', {
		default: 'Upgrade to Premium for advanced AI monitoring!',
	})}
	subHeading={$format('text_upgrade_to_premium_for_ai', {
		default:
			'Detect issues early, get automated notifications, and ensure top performance for your device.',
	})}
>
	<Text
		styleType="body-small"
		class="text-decoration-underline cursor-pointer text-primary"
		on:click={() => {
			showAboutAIModelModal = true;
		}}
	>
		{$format('about_ai_model', { default: 'About AI Model' })}
	</Text>
</PremiumUpsellAlert>
